import { init } from '@rematch/core';
import loadingPlugin from '@rematch/loading';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import { filter, filterContainer, filters } from 'appRedux/models/filter';
import originTextsModel from 'appRedux/models/originTexts';
import responseErrorModel from 'appRedux/models/responseError';
import translatedTextsModel from 'appRedux/models/translatedTexts';
import userModel from 'appRedux/models/user';

const createBrowserHistory = require('history').createBrowserHistory;

export const history = createBrowserHistory();
const store = init({
  models: {
    userModel,
    responseErrorModel,
    filters,
    filter,
    filterContainer,
    originTextsModel,
    translatedTextsModel,
  },
  plugins: [loadingPlugin()],
  redux: {
    reducers: {
      router: connectRouter(history),
    },
    middlewares: [routerMiddleware(history)],
  },
});

export default store;
